import { Onboarding } from '../models/onboarding.interfaces';

export const OnboardingMocks: Onboarding = {
  title: 'Welcome to SkyMiles, Jordan.',
  subtitle: 'Your SkyMiles Number is #1234567890',
  label: 'Make the most of your account',
  items: [
    {
      title: '1. Start Earning Miles',
      description:
        'Earn redeemable miles when you fly or spend with our many partners.',
      logo: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/earn-miles.svg',
        alt: 'Fly Delta App Logo'
      },
      link: {
        label: 'Book a Flight',
        url: 'https://www.delta.com/us/en/delta-digital/mobile'
      },
      axLink: 'Book a Flight '
    },
    {
      title: '2. Reach Status With MQDs',
      description:
        'Earn MQDs when you spend with Delta to further your Medallion Status and gain countless benefits.',
      logo: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/earn-2x-status.svg',
        alt: 'Reach Status with MQDs Logo'
      },
      link: {
        label: 'How to Reach Status',
        url: 'https://www.delta.com/myprofile/personal-details'
      },
      axLink: 'How to Earn Status '
    },
    {
      title: '3. Accelerate Your Earning',
      description:
        'The Delta SkyMiles American Express Cards can earn you miles and MQDs every time you spend.',
      logo: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/earn-double-cards.svg',
        alt: 'Accelerate Your Earning Icon'
      },
      link: {
        label: 'Learn More',
        url: 'https://www.delta.com/flight-search/book-a-flight?action=searchFlights&tripType=ROUND_TRIP&awardTravel=true&paxCount=1'
      },
      axLink: 'Learn more about Accelerate Your Earning '
    },
    {
      title: '4. Download the Fly Delta App',
      description:
        'Book trips, change seats, track your bags, monitor your SkyMiles and more!',
      logo: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/fly-delta-app.svg',
        alt: 'Use Your Miles Logo'
      },
      link: {
        label: 'Download Here',
        url: '/us/en/delta-digital/mobile'
      },
      axLink: 'Download the Fly Delta App '
    }
  ],
  action: {
    label: ''
  },
  close: {
    path: '#',
    alt: 'close'
  },
  ariaLabel: {
    close: 'Close Skymiles Onboarding'
  },
  disabled: false,
  loaded: true
};
